import React from "react";
import styled from "styled-components";


export default styled.div`
    overflow: visible;
    border-top: 1px solid lightgray;
    padding: 30px 0;
    display: block;

    @media(min-width: 768px){
        display: flex;
    }

    .lesson-today {
        display: none;
    }

    &.today .lesson-today {
        display: block;
    }

    &.today  .first-lesson .lesson-item-name .inner,
    &.today .first-lesson .lesson-item-length
    {
      background: rgb(231 241 249);
      border-color: rgb(78 153 214);
      color: rgb(78 153 214);
    }
    &.today .first-lesson .lesson-item-participants,
    &.today .first-lesson .lesson-item-time,
    &.today .first-lesson .lesson-item-recurring
     {
       color: rgb(78 153 214);
    }
    &.today .first-lesson .lesson-item-next {
        display: block;
    }
`;
